import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
    FormGroup,
} from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CategoryLayouts from '../../../../../../data/CategoryLayouts';
import { postAPI_Update_Messengers_Category } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';

export default function CategoryTag({
    visible,
    toggle,
    handleOwnCategoryTag,
    allCategoryData,
    isEdit,
    propertyId,
    LoadData,
    languageCode
}) {
    const [oldTitle, setoldTitle] = useState("0");
    const [categoryList, setCategoryList] = useState([]);
    const [tagData, setTagData] = useState({
        title: "",
        layout: 0,
        languageCode: languageCode,
        displayOrder: 0
    });
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);

    useEffect(() => {
        var list = [];
        allCategoryData.map((elem) => {
            list.push({
                id: elem.id,
                title: elem.title
            })
        });
        setCategoryList(list);
    }, [allCategoryData]);
    const handleChange = (e) => {
        setTagData({ ...tagData, layout: parseInt(e.target.value) });
    }
    const handleChangeTitle = (e) => {

        setTagData({
            ...tagData,
            title: e.target.value,
        });
        // if (tagData.title.length > 0) {
        //     const index = tagData.title.findIndex((m) => m.languageCode === locale);
        //     if (index === -1) {
        //         const newStatement = {
        //             statement: e.target.value,
        //             languageCode: locale,
        //         };
        //         setTagData({
        //             ...tagData,
        //             title: [...tagData.title, newStatement],
        //         });
        //     } else {
        //         let newArr = [...tagData.title];
        //         newArr[index].statement = e.target.value;
        //         setTagData({ ...tagData, title: newArr });
        //     }
        // } else {
        //     const newStatement = {
        //         statement: e.target.value,
        //         languageCode: locale,
        //     };
        //     setTagData({
        //         ...tagData,
        //         title: [...tagData.title, newStatement],
        //     });
        // }
    }
    const handleCategoryChange = (e) => {
        setoldTitle(e.target.value);
        var data = allCategoryData.filter(i => i.id === e.target.value);
        setTagData({
            ...tagData,
            title: data[0].title,
            layout: data[0].layout,
            languageCode: data[0].languageCode,
            displayOrder: data[0].displayOrder
        });
    }
    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === languageCode);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };
    const handleSubmit = () => {
        var body = {
            ...tagData,
            groupId: getGroupID(),
            propertyId: propertyId === "-1" ? null : propertyId,
            updator: "dashboard"
        }
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Update_Messengers_Category}`,
            data: body,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                toggle();
                var categoryId = res.data.id;
                var dat = {
                    id: categoryId,
                    ...tagData
                }
                handleOwnCategoryTag(dat);
                if (LoadData !== undefined) {
                    setTimeout(() => {
                        LoadData(languageCode);
                    }, 100);
                }
            }
        }).catch((err) => {
            console.log('err', err);
        });
    }
    const handleUpdate = () => {
        var body = {
            ...tagData,
            id: oldTitle,
            updator: "dashboard"
        }
        console.log(body);
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Update_Messengers_Category}`,
            data: body,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                toggle();
                var categoryId = res.data.id;
                var dat = {
                    id: categoryId,
                    ...tagData
                }
                if (handleOwnCategoryTag !== undefined) {
                    handleOwnCategoryTag(dat);
                }
                if (LoadData !== undefined) {
                    setTimeout(() => {
                        LoadData(languageCode);
                    }, 100);
                }
            }
        }).catch((err) => {
            console.log('err', err);
        });
    }
    return (
        <Modal isOpen={visible} toggle={() => toggle()}>
            <ModalHeader toggle={() => toggle()}>Category Tag</ModalHeader>
            <ModalBody>
                <Row>
                    {isEdit === true && (
                        <Fragment>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label>Select Category</Label>
                                <Input
                                    type="select"
                                    name="oldtitle"
                                    value={oldTitle}
                                    onChange={(e) => handleCategoryChange(e)}
                                ><option value="0">Select</option>
                                    {categoryList.map((item, i) =>
                                        <option value={item.id} key={i}>{item.title}</option>
                                    )}</Input>
                            </Colxx>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                                <Input
                                    type="number"
                                    name="displayOrder"
                                    value={tagData.displayOrder}
                                    onChange={(e) => setTagData({ ...tagData, displayOrder: e.target.value })}
                                ></Input>
                            </Colxx>
                        </Fragment>
                    )}
                    <Colxx sm={12} style={{ marginBottom: "10px" }}>
                        <Label>Title</Label>
                        <Input
                            type="text"
                            name="title"
                            value={tagData.title}
                            onChange={(e) => handleChangeTitle(e)}
                        />
                    </Colxx>
                    <Colxx sm={12} style={{ marginBottom: "10px" }}>
                        <Label>Category Layout</Label>
                        {CategoryLayouts.map((item, i) => (
                            <CustomInput
                                key={i}
                                type="radio"
                                name='layout'
                                id={"lauout_" + item.value}
                                value={item.value}
                                label={item.label}
                                checked={item.value === tagData.layout ? true : false}
                                onChange={(e) => handleChange(e)}
                            >
                            </CustomInput>
                        ))}
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                {isEdit === true ?
                    <Button
                        color="primary"
                        onClick={() => handleUpdate()}
                    >
                        Update
                    </Button> :
                    <Button
                        color="primary"
                        onClick={() => handleSubmit()}
                    >
                        Add
                    </Button>}

                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Modal>
    )
}